import Typography from '@mui/material/Typography';

interface Props {
  attemptsCount: number | undefined;
  maxAttempts: number | undefined;
  isAutoEvaluation: boolean;
}

/**
 * Displays "Intentos: N / M" for automatic evaluations when attemptsCount > 0.
 * Returns null when the counter should not be shown.
 */
export default function AttemptsCounter({ attemptsCount, maxAttempts, isAutoEvaluation }: Props) {
  if (!isAutoEvaluation) return null;
  if (typeof attemptsCount !== 'number' || attemptsCount === 0) return null;

  return (
    <Typography variant="body2" color="text.secondary">
      {`Intentos: ${attemptsCount} / ${maxAttempts}`}
    </Typography>
  );
}
